exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dot-step[data-v-4eaed6e0] {\n  width: 20px;\n  height: 20px;\n  background-color: #dfdfdf;\n  border-radius: 50%;\n  cursor: pointer;\n}\n@media screen and (max-width: 576px) {\n.dot-step[data-v-4eaed6e0] {\n      width: 10px;\n      height: 10px;\n}\n}\n.dot-step.finished[data-v-4eaed6e0] {\n    background-color: #00a09c;\n}\n.dot-step.current[data-v-4eaed6e0] {\n    background-color: #47c7bf;\n}\n", ""]);

// exports
